// @flow
import * as React from 'react'
import moment from 'moment-timezone'
import type { Coordinates, Gathering, School } from 'types'
import { type AsyncResource } from 'framework'
import { P } from 'ui/Typography'
import ContentWidthConstraint from 'ui/ContentWidthConstraint'
import Grid, { GridCell } from 'ui/Grid'
import RelatedPrograms from '../shared/RelatedPrograms'
import RailSection from '../shared/RailSection'
import GatheringPageBigDate from './BigDate'
import GatheringPageContent from './Content'
import GatheringPageInfo from './Info'
import GatheringPageMap from './Map'

type Props = {
  gathering: Gathering,
  coordinates: AsyncResource<Coordinates>,
  school: School,
}

declare var ENV: any

export default class GatheringPageDesktopContent extends React.Component<Props> {
  render = () => {
    return (
      <React.Fragment>
        <P>
          <div className="GatheringPage-content">
            <ContentWidthConstraint>
              <Grid full>
                {this.renderLeftRail()}
                <GridCell flex={2}>
                  <h2>About this Event</h2>
                  <GatheringPageContent {...this.props} />
                </GridCell>
                {this.renderRightRail()}
              </Grid>
            </ContentWidthConstraint>
          </div>
        </P>
        <P>
          <GatheringPageMap coordinates={this.props.coordinates} />
        </P>
      </React.Fragment>
    )
  }

  renderLeftRail = () => {
    return (
      <GridCell>
        <GatheringPageBigDate {...this.props} />

        <GatheringPageInfo {...this.props} />
      </GridCell>
    )
  }

  renderRightRail = () => {
    return (
      <GridCell>
        <div className="GatheringPage-relatedSchools">
          <RailSection title="Related Programs">
            <RelatedPrograms school={this.props.school} />
          </RailSection>
        </div>
      </GridCell>
    )
  }

  formatBeginsAt = (format: string): string => {
    return moment(this.props.gathering.beginsAt).tz(this.props.school.timezone).format(format)
  }

  formatEndsAt = (format: string): string => {
    return moment(this.props.gathering.endsAt).tz(this.props.school.timezone).format(format)
  }
}
